import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

import { GenericService } from '../../services/generic/generic.service';

import { HChartstockComponent } from './hchartstock.component';

@Component({
    selector: 'hchartstock-rest',
    template: '<hchartstock></hchartstock>',
    encapsulation: ViewEncapsulation.None
})

export class HChartstockRestComponent extends HChartstockComponent {

    @Input() public restPath: string = '';
    @Input() public valueField: string = '';
    @Input() public seriesField: string = '';
    @Input() public seriesTitle: string = '';
    @Output() visibleChange: EventEmitter<any> = new EventEmitter();
    public loading: Boolean = false;

    constructor(public genericService: GenericService) {
        super();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.load();
    }

    public load() {
        this.loading = true;
        this.genericService.restPath = this.restPath;
        this.genericService.getItems(0).subscribe(res => {
            if (res.length > 0) {
                var categories: any = [];
                var groups: any = [];
                if (this.type == 'pie') {
                    var group_to_values = res.reduce((obj: any, item: any) => {
                        obj[item[this.seriesField]] = obj[item[this.seriesField]] || [];
                        obj[item[this.seriesField]].push(item[this.valueField]);
                        return obj;
                    }, {});
                    var datas = Object.keys(group_to_values).map((key) => {
                        return { name: key, y: group_to_values[key][0] };
                    });
                    groups.push({ name: this.seriesTitle, data: datas });
                } else {
                    var group_to_values = res.reduce((obj: any, item: any) => {
                        obj[item[this.seriesField]] = obj[item[this.seriesField]] || [];
                        if (categories.indexOf(item.DATE_SAISIEM + '/' + item.DATE_SAISIEY) == -1) {
                            categories.push(item.DATE_SAISIEM + '/' + item.DATE_SAISIEY);
                        }
                        obj[item[this.seriesField]].push([categories.indexOf(item.DATE_SAISIEM + '/' + item.DATE_SAISIEY), item[this.valueField]]);
                        return obj;
                    }, {});
                    groups = Object.keys(group_to_values).map((key) => {
                        return { name: key, data: group_to_values[key] };
                    });
                }
                this.categories = categories;
                this.series = groups;
                this.updateSeries();
                this.updateCategories();
            } else {
                this.visibleChange.emit(false);
            }
            this.loading = false;
        });
    }

}